/*
  Given an array of stats it should return a matrix
  - First array should be the average score of each driver for all teams
  - First array should be sorted desc
  - All other arrays should be sorted by the corresponding index of the element matching driver id in the first array
 */

import {groupBy, values, orderBy, sumBy} from "lodash"
import {TeamState} from "@irati/types"

const sortByParentIndex = (a, b, sortingArr) => {
  const aParentIndex = sortingArr.find((item) => item.driver.id === a.driver.id)
  const bParentIndex = sortingArr.find((item) => item.driver.id === b.driver.id)
  return sortingArr.indexOf(aParentIndex) - sortingArr.indexOf(bParentIndex)
}

const getAllTeamsRow = (stats, drivers, formatMessage) => {
  return orderBy(stats.map(({answersAverage: averageScore, params: {driverId}}) => {
    return {
      driverId,
      driver: drivers.find(({id}) => id === driverId),
      team: {
        uuid: "x",
        public_name: formatMessage({id: "insights.heatmap.allTeams"})
      },
      averageScore
    }
  }), "averageScore", "desc")
}

const sortByScoreSum = (rows) => {
  return orderBy(rows, (row) => sumBy(row, (stat) => stat.averageScore), "desc")
}

const filterStats = (stats, headerData, drivers, formatMessage) => {
  const unprotectedStats = stats.filter(({team}) => team && team.state !== TeamState.Protected)
  const rows = values(groupBy(unprotectedStats, "team.uuid"))
  const allTeamsRow = getAllTeamsRow(headerData, drivers, formatMessage)
  let results = rows.map((row) => row.sort((a, b) => sortByParentIndex(a, b, allTeamsRow)))
  results = sortByScoreSum(results)
  results.unshift(allTeamsRow)
  return results
}

export default filterStats
